import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  image: {
    height: '100%',
    width: '100%',
  },
  overriddenImage: {
    maxHeight: '100%',
    maxWidth: '100%',
    transform: 'scale(0.5)',
  },
}));

export default useStyles;
